export default "__VITE_ASSET__0fbe6194__"